import React from "react";
import { Box, Stack } from "@chakra-ui/react";
import { AppFooter } from "../../components/AppFooter";
import { AppHeader } from "../../components/AppHeader";
import { useAuth, useClientRect } from "../../hooks";
import { AppLayoutContext } from "../contexts/layout/AppLayoutContext";
import NavBar from "../../components/NavBar/NavBar";
import { NavLinkProps } from "../../types";

export interface Props {
  includeHeader: boolean;
  children: JSX.Element | JSX.Element[];
  links: NavLinkProps[];
  isActiveLink: (index: number) => boolean;
  logout: () => void;
  showLogout: boolean;
}

const AppLayout = ({
  includeHeader,
  children,
  links,
  isActiveLink,
  logout,
  showLogout,
}: Props) => {
  const { showAppContent } = useAuth();
  // useClientRect - Hook that observes and returns the measurements (ClientRect) of a DOM element.
  const [headerRect, headerRef] = useClientRect();
  const [footerRect, footerRef] = useClientRect();
  const headerHeight = headerRect?.height || 0;
  const footerHeight = footerRect?.height || 0;

  return (
    <Stack height="100vh" className="app-layout-container" spacing={0}>
      <Box zIndex="sticky" ref={headerRef} key={`header-${showAppContent}`}>
        {includeHeader ? (
          <>
            <AppHeader title="OCC Balancing" />
            <NavBar
              links={links}
              isActiveLink={isActiveLink}
              onLogoutClick={logout}
              showLogout={showLogout}
            />
          </>
        ) : (
          <AppHeader title="&nbsp;" />
        )}
      </Box>
      <AppLayoutContext.Provider
        value={{
          headerHeight,
          footerHeight,
        }}
      >
        <Box
          flexDirection="column"
          flexGrow={1}
          height={`calc(100vh - ${headerHeight + footerHeight}px)`}
        >
          {children}
        </Box>
      </AppLayoutContext.Provider>
      <Box zIndex="sticky" ref={footerRef}>
        <AppFooter />
      </Box>
    </Stack>
  );
};

export default AppLayout;
